// messaging.js

export const DEFAULT_STATUS_TITLE = {
    EN: "Organizational Culture Survey",
    FR: "Indice de Culture",
};

export const THANKYOU_MESSAGE = {
    EN: "Thank you for contributing",
    FR: "Merci pour votre réponse au sondage",
};

export const MISSING_OR_INVALID_TOKEN = {
    EN: "We're sorry, but this survey link does not appear to be valid. Please contact your nuLogic administrator for additional information or help if this issue persists.",
    FR: "Nous sommes désolés, mais cette enquête ne semble pas valide. Veuillez contacter votre administrateur nuLogic pour obtenir plus d'informations ou de l'aide si le problème persiste.",
};

export const ERROR_ON_SUBMISSION = {
    EN: "There was an error in the submission. Please try again!",
    FR: "Une erreur s'est produite lors de l'envoi. Veuillez réessayer !",
};

// Status messages as separate constants
export const SURVEY_STATUS_UNKNOWN = {
    EN: "We are unable to get information about this survey",
    FR: "Nous ne pouvons pas obtenir d'informations sur cette enquête",
};

export const SURVEY_STATUS_COMPLETED = {
    EN: "This survey was completed",
    FR: "Cette enquête a été complétée",
};

export const SURVEY_STATUS_CLOSED = {
    EN: "This link has expired and the survey is no longer accessible",
    FR: "Ce lien a expiré et l'enquête n'est plus accessible",
};

export const ASSESSMENT_PERIOD_NOT_OPEN = {
    EN: "This assessment period is not open and cannot be accessed at this time.",
    FR: "Cette période d'évaluation n'est pas ouverte et ne peut pas être consultée pour le moment.",
};

export const SURVEY_STATUS_EXPIRED = {
    EN: "Hmm! It looks like this survey has expired",
    FR: "Hmm ! Il semble que cette enquête a expiré",
};

export const SURVEY_STATUS_CANCELLED = {
    EN: "This survey has been cancelled and is no longer available",
    FR: "Cette enquête a été annulée et n'est plus disponible",
};

export const SURVEY_STATUS_DELETED = {
    EN: "This survey link has been cancelled and is no longer available",
    FR: "Ce lien d'enquête a été annulé et n'est plus disponible",
};

// Optional helper
export function translate(msgObj, lang = "EN") {
    return (msgObj && (msgObj[lang] || msgObj.EN)) || "";
}
